import React, { Component } from 'react';
import {  ReactComponent as Calender } from 'Icons/calender.svg';
import { ReactComponent as PhotoLibrary } from 'Icons/photo-library.svg';
import { ReactComponent as ArrowDown } from 'Icons/arrowFill.svg';
import RemarksConfirmationPopup from '../remarksConfirmationPopup';
import Moment from 'moment';
class SupplierOrderScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRejectPopup: false
        }
    }
    
    handleReject = (material = '', partData = {}, type = 1) => {
        this.setState(prevState => {
            return {
                isRejectPopup: !prevState.isRejectPopup,
                remarks: '',
                material,
                partDataObj: partData,
                type
            }
        })
    }

    onConfirm = () => {
        const { material, remarks, partDataObj, type } = this.state;
        this.props.onClickApproveOrReject(type, 2, material, partDataObj, remarks);
        this.handleReject();
    }

    render() {
        const editedData = this.props.editedData || {};
        return (
            <>
                <div className="createNewPO">
                    <div className={'fs-12'} Style={{'color': '#30343C'}}><span className={'curP'} style={{'color': '#597EF7'}} onClick={this.props.onClickMyOrders}>{'My Orders'}</span><span className="ml-10 mr-10">{'>'}</span> Project Details </div>
  
                    <div className={'newOrder mr-10 mb-10 mt-20'} style={{'background': '#F4F6FF'}}>
                        <div className="subHeader">Project Details</div>
                        <div className="mt-20 flex">
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Project ID<sup>*</sup></div>
                                <div className="pValue">{editedData.project_id}</div>
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">PO Number<sup>*</sup></div>
                                <div className="pValue">{editedData.po_number}</div>
                            </div>
                            <div className={'wt-300 mr-10'}>
                                <div className="pLabel">Order Acknowledge  Number<sup>*</sup></div>
                                <div className="pValue">{editedData.order_acknowledge_number}</div>
                            </div>
                            <div className={'wt-300'}>
                                <div className="pLabel">Advance Payment in %</div>
                                <div className="pValue">{editedData.advance_payment_in_percentage}</div>
                            </div>
                            <div className={'wt-300'}>
                                <div className="pLabel">Proforma Invoice</div>
                                <div className="pValue">
                                    {editedData.proforma_invoice_doc && <div className={'uploaded-data fs-12'}>
                                        <a href={(editedData.proforma_invoice_doc || {}).url} download><PhotoLibrary className="mr-10 wt-15 ht-15 curP" />{(editedData.proforma_invoice_doc || {}).name}</a>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className={'mt-20'}>
                            <div className={'wt-300'}>
                                <div className="pLabel">Email Id</div>
                                <div className="pValue">
                                    {
                                        (editedData.email_ids || []).map(email => (
                                            <div>{email}</div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {(editedData.partDetails || []).map((partData, partIndex) => {
                    return(
                        <div className={'newOrder mr-10 mb-10'} key={partData.part_number}>
                            <div className={'flex'}>
                                <div className="subHeader">Part and RM Details</div>
                                <div className={'ml-20 subHeader'}><span style={{'color': '#92959c'}}>{'Part Number : '}</span><span style={{'color': '#597EF7'}}>{partData.part_number}</span></div>
                            </div>
                            <div className="mt-20 flex">
                                <div className={'wt-180 mr-10'}>
                                    <div className="pLabel">Drawing No</div>
                                    <div className="pValue">{partData.drawing_number}</div>
                                </div>
                                <div className={'wt-180 mr-10'}>
                                    <div className="pLabel">Drawing Rev</div>
                                    <div className="pValue">{partData.drawing_revision}</div>
                                </div>
                                <div className={'wt-180 mr-10'}>
                                    <div className="pLabel">Drawing Status</div>
                                    <div style={{'fontSize': '14px', 'fontWeight': '400'}}><span className="br-10 ht-10 p-4" style={{background: '#28C76F33'}}>{partData.drawing_status}</span></div>
                                </div>
                                <div className={'wt-180 mr-10'}>
                                    <div className="pLabel">Drawing Approved Date</div>
                                    <div className="pValue"><Calender className="wt-15 ht-15 mr-5"/>{partData.drawing_approved_date && Moment(partData.drawing_approved_date).format('DD MMM, YYYY') || ''}</div>
                                </div>
                                <div className={'wt-180 mr-10'}>
                                    <div className="pLabel">Quantity<sup>*</sup></div>
                                    <div className="pValue">{partData.quantity} {'Kg'}</div>
                                </div>
                                <div className={'wt-180 mr-10'}>
                                    <div className="pLabel">RM Net Weight</div>
                                    <div className="pValue">{partData.net_weight} {'Kg'}</div>
                                </div>
                            </div>
                            <div className="mt-20 flex">
                                <div className={'wt-180 mr-10'}>
                                    <div className="pLabel">PO Delivery Date</div>
                                    <div className="pValue"><Calender className="wt-15 ht-15 mr-5"/>{partData.po_delivery_date && Moment(partData.po_delivery_date).format('DD MMM, YYYY') || ''}</div>
                                </div> 
                                <div className={'wt-180 mr-10'}>
                                    <div className="pLabel">Proposed Delivery Date</div>
                                    <div className="pValue"><Calender className="wt-15 ht-15 mr-5"/>{partData.proposed_delivery_date && Moment(partData.proposed_delivery_date).format('DD MMM, YYYY') || ''}</div>
                                </div> 
                            </div>
                            <div className={'rmTable br-5 supplier'}>
                                <div className={'table-wrapper col-1'}>
                                    <table cellSpacing={0} width={'100%'}>
                                            <tr style={{'background': '#F4F6FF'}}>
                                                <th>RM Grade</th>
                                                <th>RM Used For</th>
                                                <th>Required Quantity</th>
                                                <th>Required Date</th>
                                                <th>Expected Date</th>
                                                <th>Document</th>
                                                <th>Remark</th>
                                                <th className={'pSticky'}>Actions</th>
                                            </tr>
                                            {(partData.rawMaterials || []).map((material, mIndex) => {
                                            return(<tr>
                                            <td className={'tdWidth'}>
                                                {material.product_grade}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {material.product_description}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {material.required_quantity} {'Kg'}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {material.required_date && Moment(material.required_date).format('DD MMM, YYYY') || ''}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {material.expected_date && Moment(material.expected_date).format('DD MMM, YYYY') || ''}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {(material.uploaded_doc || {}).name && <div className={'uploaded-data fs-14'}>
                                                            <a href={(material.uploaded_doc || {}).url} download><PhotoLibrary className="mr-10 wt-15 ht-15" />{(material.uploaded_doc || {}).name}</a>
                                                    </div>}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {material.remarks}
                                            </td>
                                            <td>
                                                {
                                                    material.approverMessage && <div className={material.is_accept == 1 ? 'success-color fs-14' : 'error-color fs-14'}>{material.approverMessage}</div>
                                                }
                                                {material.rejected_remarks &&
                                                    <div className={'mt-5'}>{material.rejected_remarks}</div>
                                                }
                                                {(material.is_approval_required && !material.is_accept) && <div className={'flex'}>
                                                    <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold wt-60 curP'} onClick={() => this.props.onClickApproveOrReject(1, 1, material, partData)}>Approve</div>
                                                    <div className={'pv-5 pl-5 pr-5 loi-cancelled-color border-red  br-5 fs-12 fSemibold wt-60 curP'} onClick={() => this.handleReject(material, partData, 1)}>Reject</div>
                                                </div>}
                                            </td>
                                            </tr>)})}
                                    </table>
                                </div>
                            </div>
                            <div className={'rmTable br-5 supplier'}>
                                <div className={'pv-10 ph-20 productionHeader'}>
                                    <div className={'flex flex-between flex-middle'}>
                                        <div>Production Status</div>
                                        <ArrowDown  className='curP'/>
                                    </div>
                                </div>
                                <div className={'table-wrapper col-1'}>
                                    <table width={'100%'} cellSpacing={0}>
                                        <tr style={{'background': '#F4F6FF'}}>
                                            <th className={'wt-150'}>Process</th>
                                            <th>Start Date</th>
                                            <th>Completion Date</th>
                                            <th>Production Status</th>
                                            <th>Document</th>
                                            <th>Remark</th>
                                            <th className={'wt-80'}>Actions</th>
                                        </tr>
                                        {(partData.productionStatus || []).map((processData, pIndex) => {
                                        return(<tr>
                                            <td className={'tdWidth'}>
                                                {processData.process}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {processData.start_date && Moment(processData.start_date).format('DD MMM, YYYY') || ''}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {processData.completion_date && Moment(processData.completion_date).format('DD MMM, YYYY') || ''}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {processData.production_status_name}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {processData.uploaded_doc && <div className={'uploaded-data fs-14'}>
                                                        <a href={(processData.uploaded_doc || {}).url} download><PhotoLibrary className="mr-10 wt-15 ht-15 curP"/>{(processData.uploaded_doc || {}).name}</a>
                                                </div>}
                                            </td>
                                            <td className={'tdWidth'}>
                                                {processData.remarks}
                                            </td>
                                            <td>
                                                {
                                                        processData.approverMessage && <div className={processData.is_accept == 1 ? 'success-color fs-14 mt-5' : 'error-color fs-14 mt-5'}>{processData.approverMessage}</div>
                                                    }
                                                    {processData.rejected_remarks && 
                                                        <div className={'mt-5'}>{processData.rejected_remarks}</div>
                                                    }
                                                {processData.is_approval_required && !processData.is_accept && <div className={'flex'}>
                                                    <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold wt-60 curP'} onClick={() => this.props.onClickApproveOrReject(2, 1, processData, partData)}>Approve</div>
                                                    <div className={'pv-5 pl-5 pr-5 loi-cancelled-color border-red  br-5 fs-12 fSemibold wt-60 curP'} onClick={() => this.handleReject(processData, partData, 2)}>Reject</div>
                                                </div>}
                                            </td>
                                        </tr>)})}
                                    </table>
                                </div>
                            </div>
                        </div>
                    )})}
                </div>
                {this.state.isRejectPopup && 
                    <RemarksConfirmationPopup 
                        onChange={(e) => this.setState({ remarks: e.target.value })}
                        onCancel={this.handleReject}
                        onConfirm={this.onConfirm}
                        value={this.state.remarks}
                    />
                }
            </>
        )
    }
}

export default SupplierOrderScreen;
